// extracted by mini-css-extract-plugin
module.exports = {"container":"DeliveryAndPaymentPage_container__3hj7X","item":"DeliveryAndPaymentPage_item__24bIr"};